import WizardVM from './wizard-vm';
import Vue from 'vue';
import 'libs/vue-extensions';
export default {
  init(element) {
    console.log('Kadenze.WizardDemo initialization function called');
    let vm = new Vue(WizardVM);
    let data = {};
    vm.coursename = 'testcourse2';
    vm.termname = 'testterm2';
    vm.attrs = {};
    vm.attrs.steps = [{
      label: Kadenze.I18n.t('wizard.select_items'),
      title: `${Kadenze.I18n.t('wizard.step')} 1`,
      icon: 'kf-info',
    },
    {
      label: Kadenze.I18n.t('wizard.select_more_items'),
      title: `${Kadenze.I18n.t('wizard.step')} 2`,
      icon: 'kf-star',
    },
    {
      label: Kadenze.I18n.t('wizard.review'),
      title: `${Kadenze.I18n.t('wizard.step')} 3`,
      icon: 'kf-info',
    }];
    vm.attrs.showCancelBtn = true;
    vm.attrs.cancelBtnLabel = 'nevermind';
    vm.attrs.finalStepLabel = 'download';
    vm.$mount(element);
  }
};

